import { plainToClass } from "class-transformer";
import { DateUpdatedSection } from "../../../../shared/components/date-updated-section/date-updated-section.view";
import { Unique } from "../../../../shared/scripts/array-functions";
import { IFilter } from "../../../../shared/scripts/filtering/filtering.entities";
import { GetSelectedDate, GetSelectedDropdownValues, InitializeDateSelector, InitializeFilterDropdown, ResetDateFilters, ResetDropdownFilters } from "../../../../shared/scripts/filtering/filtering.utilities";
import { SiteInfo } from "../../sites/shared/sites.entities";
import { SiteMilestone } from "../../sites/site-activation/scripts/site-activation.entities";
import { ContractDetailsTab } from "../components/contract-details-tab/contract-details.tab";
import { ContractHistoryTab } from "../components/contract-history-tab/contract-history.tab";
import { ContractSummaryTab } from "../components/contract-summary-tab/contract-summary.tab";
import { Contract, ContractHistory } from "./contracts.entities";

export class ContractsPage implements IFilter {

    contracts: Contract[];
    contractsHistory: ContractHistory[];
    siteMilestones: SiteMilestone[];

    activeTab: string;
    contractSummaryTab: ContractSummaryTab;
    contractHistoryTab: ContractHistoryTab;
    contractDetailsTab: ContractDetailsTab;

    constructor(contractsDictionaryJson: any, contractsJson: any, contractsHistoryJson: any, siteInfoJson: any, siteMilestonesJson: any, lastUpdatedJson: any) {

        $(() => {

            new DateUpdatedSection(lastUpdatedJson);

            this.initializeSiteMilestones(siteInfoJson, siteMilestonesJson); //has to be first as site milestones are added to contract
            this.initializeContracts(contractsDictionaryJson, contractsJson, contractsHistoryJson);
            this.initializeFilters();

            this.contractSummaryTab = new ContractSummaryTab();
            this.contractDetailsTab = new ContractDetailsTab(this.contracts);
            this.contractHistoryTab = new ContractHistoryTab(this.contractsHistory);

            $('#loading-indicator').hide();
            //$('#loading-indicator').addClass('d-none');
            $('.loaded-content').removeClass('invisible');

            this.showTab("#contracts-summary");

        });
    }

    changeView(selectedOption: any): void {
        let views: string[] = ['#contracts-summary', '#contracts-details', '#contracts-history'];
        views.forEach((id: string) => $(id).removeClass("show active"));

        $(selectedOption).tab('show');
        this.showTab(selectedOption);
    }

    initializeContracts(contractsDictionaryJson: any, contractsJson: any, contractsHistoryJson: any): void {

        //const start = new Date().getTime();

        let contractsDictionary: Map<string, string> = new Map<string, string>();
        contractsDictionaryJson.map((entry: any) => {
            contractsDictionary.set(entry.Key, entry.Value);
        });

        this.contractsHistory = plainToClass(ContractHistory, <ContractHistory[]>contractsHistoryJson);
        this.contractsHistory.map((history: ContractHistory) => {
            if (contractsDictionary.has(history.ContractNumber)) {
                history.ContractName = contractsDictionary.get(history.ContractNumber);
            }
            else { history.ContractName = "Unknown"; }
            history.initialize();

            return history;
        });

        this.contracts = plainToClass(Contract, <Contract[]>contractsJson);
        this.contracts.map((contract: Contract) => {
            if (contractsDictionary.has(contract.ContractNumber)) {
                contract.ContractName = contractsDictionary.get(contract.ContractNumber);
            }
            else { contract.ContractName = "Unknown"; }
            contract.initialize();
            contract.setContractHistory(this.contractsHistory.filter((history: ContractHistory) => history.ContractNumber == contract.ContractNumber));
            contract.setSiteMilestones(this.siteMilestones.filter((milestone: SiteMilestone) => (milestone.SiteNumber == contract.SiteNumber && milestone.PrimeContract == contract.PrimeContract)));

            return contract;
        });

        //console.log(this.contracts);
        //const duration = new Date().getTime() - start;
        //console.log(`contracts load = ${(new Date().getTime() - start) / 1000}s`);
    }

    initializeSiteMilestones(siteInfoJson: any, siteMilestonesJson: any): void {

        let milestoneDictionary: Map<number, string> = SiteInfo.CreateNameMap(siteInfoJson, undefined);

        this.siteMilestones = plainToClass(SiteMilestone, <SiteMilestone[]>siteMilestonesJson);
        this.siteMilestones.map((milestone: SiteMilestone) => {
            if (milestoneDictionary.has(milestone.SiteNumber)) {
                milestone.SiteName = milestoneDictionary.get(milestone.SiteNumber);
            }
            else { milestone.Milestone = "Unknown"; }
            milestone.initialize();
            return milestone;
        });
    }

    initializeFilters(): void {

        InitializeDateSelector('changed-since-date', this);
        InitializeDateSelector('added-since-date', this);

        InitializeFilterDropdown('#prime-contract-dropdown', Unique(this.contracts.map((contract: Contract) => contract.PrimeContract), true, ["Infrastructure"]), this);
        InitializeFilterDropdown('#contract-type-dropdown', Unique(this.contracts.map((contract: Contract) => contract.ContractType), true), this);
        InitializeFilterDropdown('#status-group-dropdown', Unique(this.contracts.map((contract: Contract) => contract.StatusGroup), true), this);
        //InitializeFilterDropdown('#vanguard-site-dropdown', Unique(this.contracts.map((contract: Contract) => contract.VanguardSiteDisplay), true, ["Not Applicable"]), this);
        //InitializeFilterDropdown('#status-dropdown', Unique(this.contracts.map((contract: Contract) => contract.Status), true), this);
    }

    showTab(tabId: string): void {

        //prime-contract always shown

        if (tabId == "#contracts-summary") {
            this.toggleDateAsterick(true);

            ['#status-group-filter'].forEach((id: string) => $(id).hide());
            //['#contract-type-filter', '#changed-since-filter', '#added-since-filter', '#vanguard-site-filter'].forEach((id: string) => $(id).show());
            ['#contract-type-filter', '#changed-since-filter', '#added-since-filter'].forEach((id: string) => $(id).show());
        }
        else if (tabId == "#contracts-details") {
            this.toggleDateAsterick(false);

            //['#contract-type-filter', '#status-group-filter', '#changed-since-filter', '#added-since-filter', '#vanguard-site-filter'].forEach((id: string) => $(id).show());
            ['#contract-type-filter', '#status-group-filter', '#changed-since-filter', '#added-since-filter'].forEach((id: string) => $(id).show());
            this.contractDetailsTab.refresh();
        }
        else if (tabId == "#contracts-history") {
            this.toggleDateAsterick(false);

            //['#changed-since-filter', '#added-since-filter', '#vanguard-site-filter'].forEach((id: string) => $(id).hide());
            ['#changed-since-filter', '#added-since-filter'].forEach((id: string) => $(id).hide());
            ['#contract-type-filter', '#status-group-filter'].forEach((id: string) => $(id).show());
            this.contractHistoryTab.refresh();
        }
        this.activeTab = tabId;
        this.triggerFilter();
    }

    triggerFilter(): void {
        //console.log("filter triggered");

        if (this.activeTab == "#contracts-summary") {
            this.contractSummaryTab.updateContent(this.filterContracts(this.activeTab), this.filterContracts('contracts-summary-achievement-chart'));
        }
        else if (this.activeTab == "#contracts-details") {
            this.contractDetailsTab.updateContent(this.filterContracts(this.activeTab));
        }
        else if (this.activeTab == "#contracts-history") {
            this.contractHistoryTab.updateContent(this.filterContractsHistory());
        }
    }

    filterContracts(view: string): Contract[] {
        let matchingList: Contract[] = [];
        let matches: boolean;
        this.contracts.forEach((contract: Contract) => {
            matches = true; //must match all filters

            if (view == "#contracts-summary") {
                //if (!contract.matchesFilter(GetSelectedDropdownValues('#prime-contract-dropdown'), GetSelectedDropdownValues('#contract-type-dropdown'), undefined, GetSelectedDate("#changed-since-date"), GetSelectedDate("#added-since-date"), GetSelectedDropdownValues('#vanguard-site-dropdown'))) {
                if (!contract.matchesFilter(GetSelectedDropdownValues('#prime-contract-dropdown'), GetSelectedDropdownValues('#contract-type-dropdown'), undefined, GetSelectedDate("#changed-since-date"), GetSelectedDate("#added-since-date"))) {
                    matches = false;
                }
            }
            else if (view == "#contracts-details") {
                //if (!contract.matchesFilter(GetSelectedDropdownValues('#prime-contract-dropdown'), GetSelectedDropdownValues('#contract-type-dropdown'), GetSelectedDropdownValues('#status-group-dropdown'), GetSelectedDate("#changed-since-date"), GetSelectedDate("#added-since-date"), GetSelectedDropdownValues('#vanguard-site-dropdown'))) {
                if (!contract.matchesFilter(GetSelectedDropdownValues('#prime-contract-dropdown'), GetSelectedDropdownValues('#contract-type-dropdown'), GetSelectedDropdownValues('#status-group-dropdown'), GetSelectedDate("#changed-since-date"), GetSelectedDate("#added-since-date"))) {
                    matches = false;
                }
            }
            else if (view == "contracts-summary-achievement-chart") {
                //if (!contract.matchesFilter(GetSelectedDropdownValues('#prime-contract-dropdown'), GetSelectedDropdownValues('#contract-type-dropdown'), undefined, undefined, undefined, GetSelectedDropdownValues('#vanguard-site-dropdown'))) {
                if (!contract.matchesFilter(GetSelectedDropdownValues('#prime-contract-dropdown'), GetSelectedDropdownValues('#contract-type-dropdown'), undefined, undefined, undefined)) {
                    matches = false;
                }
            }
            if (matches) { matchingList.push(contract); }
        });        
        return matchingList;
    }

    filterContractsHistory(): ContractHistory[] {
        let matchingList: ContractHistory[] = [];
        let matches: boolean;
        this.contractsHistory.forEach((contract: ContractHistory) => {
            matches = true; //must match all filters
            if (this.activeTab == "#contracts-history") {
                if (!contract.matchesFilter(GetSelectedDropdownValues('#prime-contract-dropdown'), GetSelectedDropdownValues('#contract-type-dropdown'), GetSelectedDropdownValues('#status-group-dropdown'))) {
                    matches = false;
                }
            }
            if (matches) { matchingList.push(contract); }
        });
        return matchingList;
    }

    showContractDetails(selectedContractNumber: any, view: string): void {
        this.contractDetailsTab.showModal(this.contracts.find((c: Contract) => c.ContractNumber == selectedContractNumber), view);
    }

    resetFilters(): void {

        //ResetDropdownFilters(['#prime-contract-dropdown', '#contract-type-dropdown', '#status-group-dropdown', '#vanguard-site-dropdown']);
        ResetDropdownFilters(['#prime-contract-dropdown', '#contract-type-dropdown', '#status-group-dropdown']);
        ResetDateFilters(['#changed-since-date', '#added-since-date']);

        this.contractDetailsTab.clearSearchBar();
        this.contractHistoryTab.clearSearchBar();
    }

    setOptionEnabled(dropdownId: string, values: string[], disabled: boolean): void {
        $(dropdownId + " option").each(function () {
            if (values.includes($(this).val().toString())) {
                $(this).prop('disabled', disabled);
            }
        });
        $(dropdownId).selectpicker('refresh');
    }

    toggleDateAsterick(showAsterick: boolean): void {
        if (showAsterick) { $('.date-filter-asterick').show(); }
        else { $('.date-filter-asterick').hide(); }
    }

    showDetailTableModal(id: any, type: string): void {
        this.contractSummaryTab.showDetailTableModal(id, type);
    }
}